__webpack_require__.p = "https://static.klouser.app/builds/klouser-ui-stg-20260227-174824/";